import src from "IMAGE";
export default { src, width: 772, height: 772, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOklEQVR42n2OsREAMAgC2VSy/xKJRe4gRyy+QFEAgDpQKKG1iUoGfgxXx9eKLRk62eCNGA1WslnhmhsqZxffiyLTCwAAAABJRU5ErkJggg=="};
